import { motion, useReducedMotion } from "framer-motion";
import { Check } from "lucide-react";

const BULLETS = [
    "Persönlich geführt – fester Ansprechpartner",
    "Professionelle Ausstattung & geschultes Team",
    "Transparente Angebote ohne Kleingedrucktes",
    "Diskret, pünktlich, gewissenhaft",
    "Versichert über gewerbliche Haftpflicht",
];

const ABOUT_IMG =
    "https://images.pexels.com/photos/6166469/pexels-photo-6166469.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=820&w=1100";

export default function About() {
    const reduce = useReducedMotion();
    return (
        <section
            id="ueber-uns"
            data-testid="about-section"
            className="relative py-20 sm:py-24 lg:py-28 border-t border-white/[0.06]"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                    <motion.div
                        initial={reduce ? false : { opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#7BD3FF]">
                            Über uns
                        </p>
                        <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white">
                            Persönliche Reinigung.
                            <br />
                            <span className="text-chrome">
                                Gemacht für Tirol.
                            </span>
                        </h2>
                        <p className="mt-5 text-[#C9D3E1] text-base leading-relaxed">
                            Alpen Reinigung steht für eine moderne, persönlich geführte Reinigung in Innsbruck und Umgebung. Unser Anspruch: Qualität, die man sieht – und Zuverlässigkeit, auf die man baut.
                        </p>

                        <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
                            {BULLETS.map((b) => (
                                <li
                                    key={b}
                                    className="flex items-start gap-3 rounded-xl border border-white/[0.08] bg-white/[0.02] p-3"
                                >
                                    <span className="mt-0.5 h-6 w-6 rounded-md bg-[rgba(46,168,255,0.12)] border border-[rgba(46,168,255,0.25)] flex items-center justify-center shrink-0">
                                        <Check className="h-3.5 w-3.5 text-[#7BD3FF]" />
                                    </span>
                                    <span className="text-sm text-[#F4F7FB]">
                                        {b}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </motion.div>

                    <motion.div
                        initial={reduce ? false : { opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.6, delay: 0.05 }}
                        className="relative"
                    >
                        <div className="absolute -inset-3 rounded-[28px] bg-[rgba(46,168,255,0.06)] blur-2xl" aria-hidden="true" />
                        <div className="relative rounded-[24px] overflow-hidden border border-white/[0.10] card-elevated">
                            <div className="aspect-[5/4] relative">
                                <img
                                    src={ABOUT_IMG}
                                    alt="Detail einer professionellen Glasreinigung in Aktion"
                                    className="absolute inset-0 h-full w-full object-cover"
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#07090C]/85 via-[#07090C]/30 to-transparent" />
                                <div className="absolute bottom-5 left-5 right-5">
                                    <div className="flex items-center gap-3">
                                        <div className="h-10 w-10 rounded-full bg-[rgba(14,20,31,0.85)] border border-white/[0.10] flex items-center justify-center font-mono text-xs text-[#7BD3FF]">
                                            FS
                                        </div>
                                        <div>
                                            <p className="text-sm text-white font-medium">Faisal Safi</p>
                                            <p className="text-xs text-[#8FA0B8]">Inhaber · Innsbruck</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
